import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/boost/using-tradelines-to-improve-your-credit-score.png")